<template>
  <div class="flex flex-col pb-18">
    <ul ref="element">
      <li
        v-for="subItem in subNavigation"
        :key="subItem.page.id"
        class="mb-4 w-screen"
      >
        <SubItemMobile :sub-item="subItem" @height-change="onHeightChange" />
      </li>
    </ul>
  </div>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script setup>
const props = defineProps({
  subNavigation: {
    type: Array,
    required: true,
  },
  show: {
    type: Boolean,
    required: true,
  },
})

const element = ref(null)

function onHeightChange(newHeight) {
  emit('heightChange', element.value.offsetHeight + newHeight)
}

// watch for open state
watchEffect(async () => {
  if (props.show) {
    // Wait until the DOM is ready
    await nextTick()
    emit('heightChange', element.value.offsetHeight)
  }
})

const emit = defineEmits(['back', 'heightChange'])
</script>
